import { isNullish } from '@local/utils'

import { PlaceRecommend } from '@web/federation/gql/graphql'
import { ConvertedPlaceRecommend } from '@web/pages/v5/home/DdayRecommendPlacesSection'
import { Nullish } from '@web/types'

export const getformattedDistance = (distanceInMeters: number): Nullish<string> => {
  if (isNullish(distanceInMeters)) {
    return null
  }

  if (distanceInMeters < 1000) {
    return `${distanceInMeters}m`
  }

  if (distanceInMeters < 10000) {
    const distanceInKm = distanceInMeters / 1000
    const roundedKm = Math.floor(distanceInKm * 10) / 10
    return `${roundedKm}km`
  }

  const distanceInKm = distanceInMeters / 1000
  const roundedKm = Math.round(distanceInKm)
  return `${roundedKm}km`
}

export const convertPlaceRecommend = (place: PlaceRecommend): ConvertedPlaceRecommend => {
  const { id, placeName, images, categoryName, reviewCount, distance } = place

  return {
    id,
    placeName,
    images,
    categoryName,
    reviewCountText: reviewCount > 9999 ? '9,999+' : reviewCount.toLocaleString(),
    distanceText: getformattedDistance(distance),
  }
}
